import { __rest } from 'tslib';
import React from 'react';
import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className } })));
})(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: Object.assign({ padding: theme.spacing(1), backgroundColor: theme.palette.common.white, color: theme.palette.text.primary, borderRadius: theme.spacing(0.5), boxShadow: `0px ${theme.spacing(0.1)} ${theme.spacing(0.7)} ${theme.palette.grey[100]}` }, theme.typography.body1),
}));

export { PeekTooltip, PeekTooltip as default };
